import { NgModule } from '@angular/core';
import { AuthPortalGuard } from '../shared/services/auth-guard';
import { Routes, RouterModule } from '@angular/router';
import { PortalComponent } from './portal.component';

const routes: Routes = [
    {
        path: '',
        canActivate: [AuthPortalGuard],
        component: PortalComponent,
        children: [
            { path: 'applications', loadChildren: 'app/portal/applications/applications.module#ApplicationsModule' },
            { path: 'types', loadChildren: 'app/portal/application-types/application-types.module#ApplicationsTypesModule' },
            { path: '', redirectTo: 'types', pathMatch: 'full' }
        ]
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class PortalRoutingModule { }
